import { defineStore, storeToRefs } from "pinia";
import { queries } from "../queries";
import { useQuery } from "@tanstack/vue-query";
import { useUserInitStore } from "./user-init.store";
import { watchEffect } from "vue";
export const useUserStore = defineStore("login_user", () => {
    const { data: newData, refetch } = useQuery(queries.user.loginUser());
    const userInitStore = useUserInitStore();
    const { user } = storeToRefs(userInitStore);
    watchEffect(() => {
        userInitStore.setUser(newData.value ?? null);
    });
    return {
        user,
        refetch,
    };
});
